import selectPrivacyModeEnabled from 'app-components/hooks/privacyMode/selectPrivacyModeEnabled';
import { useAppSelector } from './redux';

type MaskValueFn = (value?: unknown) => string | number | null | undefined;

// stable functions for return
const maskFunc: MaskValueFn = () => '***';
const showFunc: MaskValueFn = (value?: string) => value;

// Use this method when not using a formatter. This can be used to mask any value.
export function useRawPrivacyModeMask() {
  const privacyModeEnabled = useAppSelector(selectPrivacyModeEnabled);

  return privacyModeEnabled ? maskFunc : showFunc;
}
